import { Link } from 'react-router-dom'

interface HeaderProps {
  onChooseFiles?: () => void
}

export default function Header({ onChooseFiles }: HeaderProps) {
  return (
    <header className="shell header">
      <Link className="brand" to="/">
        <img
          src="/logo-mark.svg"
          alt=""
          width="24"
          height="24"
          aria-hidden="true"
          className="brand-logo"
        />
        <span>HEIC Studio</span>
      </Link>
      <nav className="nav" aria-label="Primary">
        <Link to="/#how">How it works</Link>
        <Link to="/#limits">Limits</Link>
        <Link to="/#faq">FAQ</Link>
      </nav>
      <button
        type="button"
        className="button"
        onClick={onChooseFiles}
        aria-label="Choose HEIC or HEIF files"
      >
        Choose HEIC files
      </button>
    </header>
  )
}
